




















import { Component, Mixins } from "vue-property-decorator";
import { Point, Size, Rectangle } from "../../domain/drawing";
import { ModelEditableMixin } from "../system/mixins";
import { OptionDropDownSelector } from "../system/selectors";
import { default as PointEditor } from "./PointEditor.vue";
import { default as SizeEditor } from "./SizeEditor.vue";
import { StandardOption } from "../system/selectors/mixins";

@Component({
  components: {
    OptionDropDownSelector,
    PointEditor,
    SizeEditor,
  },
})
export default class RectangleCoordinateEditor extends Mixins(ModelEditableMixin) {
  // ModelEditableMixinと同時に使う事.ModelEditableMixin利用APIの宣言.
  writePropertyWhenValid: (writer: (source: Rectangle) => void) => void;
  readPropertyOrDefault: <T>(reader: (source: Rectangle) => T, defaultValue: T) => T;

  data() {
    return {
      locationAccessor: null as { read: (s: Rectangle) => Point, write: (s: Rectangle, v: Point) => void },
    };
  }
  locationAccessor: { read: (s: Rectangle) => Point, write: (s: Rectangle, v: Point) => void };

  created() {
    this.locationAccessor = this.locationAccessors[0].value;
  }

  get locationAccessors(): StandardOption<{ read: (s: Rectangle) => Point, write: (s: Rectangle, v: Point) => void }>[] {
    return [
      new StandardOption(
        "左上",
        {
          read: s => s.topLeft,
          write: (s, v) => s.topLeft = v,
        }),
      new StandardOption(
        "中央",
        {
          read: s => s.center,
          write: (s, v) => s.topLeft = v.subtract(s.size.multiply(0.5).toPoint()),
        }),
      new StandardOption(
        "右下",
        {
          read: s => s.bottomRight,
          write: (s, v) => s.topLeft = v.subtract(s.size.toPoint()),
        }),
    ];
  }

  get location(): Point {
    return this.readPropertyOrDefault(s => this.locationAccessor.read(s), new Point(null, null));
  }

  set location(value: Point) {
    this.writePropertyWhenValid(s => this.locationAccessor.write(s, value));
  }

  get size(): Size {
    return this.readPropertyOrDefault(s => s.size, new Size(null, null));
  }

  set size(value: Size) {
    this.writePropertyWhenValid(s => s.size = value);
  }
}
